/*! @azure/msal-common v14.15.0 2024-10-03 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "14.15.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
